import { parseISO, differenceInSeconds, differenceInMinutes, differenceInHours, differenceInDays, differenceInMonths, differenceInYears } from 'date-fns';




export function formatDateToHHMM(date = new Date()) {
    // Create a new Date object from the MongoDB date
    const d = new Date(date);

    // Extract hours and minutes
    let hours = d.getHours();
    const minutes = d.getMinutes();

    // Determine AM or PM
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert 24-hour time to 12-hour time
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'

    // Pad minutes with leading zeros if needed
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;

    // Format the time as "HH:MM AM/PM"
    const formattedTime = `${hours}:${minutesStr} ${ampm}`;

    return formattedTime;
}

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
        month: 'long',   // Full month name
        day: 'numeric',  // Day of the month
        year: 'numeric'  // Full year
    });
};

export function getRelativeTime(isoString) {
    const date = parseISO(isoString);
    const now = new Date();
  
    const seconds = differenceInSeconds(now, date);
    const minutes = differenceInMinutes(now, date);
    const hours = differenceInHours(now, date);
    const days = differenceInDays(now, date);
    const months = differenceInMonths(now, date);
    const years = differenceInYears(now, date);
  
    if (seconds < 60) {
        return "just now"; // Less than a minute
      } else if (minutes < 60) {
        return `${minutes}m`; // Minutes
      } else if (hours < 24) {
        return `${hours}h`; // Hours
      } else if (days < 30) {
        return `${days}d`; // Days
      } else if (months < 12) {
        return `${months}mo`; // Months
      } else {
        return `${years}y`; // Years
      }
    }
  